import gql from 'graphql-tag';
import {TIPO_ESTADO_ENVIOS} from '@/resources/constants';

export const QUERY_GET_OPERATIONS = gql(`
query BusquedaReclamaciones($criteria: ItemCriteriaInput, $idioma: String){
   listaOperaciones (criteria: $criteria) {
      totalElements
      firstElement
      results {
         acreedorApellidos	
         acreedorIdLegal	
         acreedorNombre
         acreedorRazonSocial
         acreedorTipoSociedad
         acreedorUuid
         clienteApellidos
         clienteId
         referenciaCliente
         clienteIdLegal
         clienteNombre
         deudorApellidos
         deudorIdLegal
         deudorNombre
         deudorRazonSocial
         deudorTipoSociedad
         deudorUuid
         divisa
         fechaAlta
         productoCodigo
         productoId
         token
         tramitadorApellidos
         tramitadorEmail
         tramitadorNombre
         tramitadorUuid
         listaReclamaciones {
            totalElements
            firstElement
            results {
               acreedorApellidos	
               acreedorIdLegal	
               acreedorNombre
               acreedorRazonSocial
               acreedorTipoSociedad
               acreedorUuid
               clienteApellidos
               clienteId
               clienteIdLegal
               clienteNombre
               deudorApellidos
               deudorIdLegal
               deudorNombre
               deudorRazonSocial
               deudorTipoSociedad
               deudorUuid
               divisa
               estado
               fechaAlta
               productoCodigo
               productoId
               token
               totalImpagos
               totalPendiente
               tramitadorApellidos
               tramitadorEmail
               tramitadorNombre
               tramitadorUuid
               literalEstado(idioma: $idioma) {
                  valor
              }
            }
         }
      }
   }
}`)

export const QUERY_GET_OPERATIONS_WITH_IMPAGOS = gql(`
query BusquedaReclamaciones($criteria: ItemCriteriaInput, $idioma: String){
   listaOperaciones (criteria: $criteria) {
      totalElements
      firstElement
      results {
         uuid
         acreedorApellidos	
         acreedorIdLegal	
         acreedorNombre
         acreedorRazonSocial
         acreedorTipoSociedad
         acreedorUuid
         clienteApellidos
         clienteId
         referenciaCliente
         clienteIdLegal
         clienteNombre
         deudorApellidos
         deudorIdLegal
         deudorNombre
         deudorRazonSocial
         deudorTipoSociedad
         deudorUuid
         divisa
         fechaAlta
         productoCodigo
         productoId
         token
         origenDeuda
         literalOrigenDeudaDetalle(idioma: $idioma) {
            clave
            valor
         } 
         tramitadorApellidos
         tramitadorEmail
         tramitadorNombre
         tramitadorUuid
         cartera {
            nombre
            usuarioCliente {
               cliente {
                  contratos {
                     limiteOperacionPPJJ
                     limiteOperacionPPFF
                     periodoExpiracionPPJJ
                     periodoExpiracionPPFF
                     id
                     nombre
                     productos {
                        id
                     }
                  }
               }
            }
         }
         listaImpagos {
            uuid
            token
            referenciaCliente
            reclamacionToken
            importe
            importePendiente
            fechaVencimiento
            fechaOrigen
            recuperado
            notas
            fechaAlta
            pagos {
               importe
               importeRecuperado
               divisa
               fechaPago
               fechaAlta
            }
            reclamacion {
               listadoTransiciones {
                  estadoPrevio
                  estadoPosterior
               }
               estado
               token
               fechaAlta
            }
         }
      }
   }
}`);

export const QUERY_DETALLE_OPERACION = gql(`
   query BusquedaOperacion($uuid: String, $idioma: String){
      operacion(uuid:$uuid){
         uuid
         id
         token
         tramitadorUuid
         fechaAlta
         fechaPublicacion                      
         fechaInicio
         fechaFin
         numReclamaciones
         totalDeuda
         totalDeudaPendiente
         totalDeudaRecuperada
         totalDeudaPublicadaFicheroMorosidad
         numImpagos
         divisa
         origenDeuda
         referenciaCliente
         jsonSegmento
         segmento {
            nombre
            isUsedSegmento
            id
            activo
         }
         reclamaciones {
            token
            documentosReclamacion {
               id
               tipo
               clave
               filename
            }
            envioRequerimientoBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_NOTIFICACION + `"){
               estado
               envioEncontradoBBDD
               literalCodigoEnvio(idioma: $idioma){
                  valor
               }
               literalEstadoEnvio(idioma: $idioma){
                  valor
               }
               literalTipoEnvio(idioma: $idioma){
                  valor
               }
               fechaEnvio
               localizadorProveedor
               numeroSeguimiento
               token
               uuidPeticionEnvio
               tipoEnvio
               servicioProveedor
               certPdf
               postalNote
               postalCert
               stampedContent
               documentosReqInc {
                  tipo
                  clave
                  filename
                }
            }
            envioInclusionBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_PUBLICACION + `"){
               estado
               envioEncontradoBBDD
               literalCodigoEnvio(idioma: $idioma){
                  valor
               }
               literalEstadoEnvio(idioma: $idioma){
                  valor
               }
               literalTipoEnvio(idioma: $idioma){
                  valor
               }
               fechaEnvio
               localizadorProveedor
               numeroSeguimiento
               token
               uuidPeticionEnvio
               tipoEnvio
               servicioProveedor
               certPdf
               postalNote
               postalCert
               stampedContent
               documentosReqInc {
                  tipo
                  clave
                  filename
                }
            }
            actaProvisionalDoc {
               filename
               tipo
               clave
            }
            actaProvisionalBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_ACTA_PROVISIONAL + `"){
               envioEncontradoBBDD
               estado
               localizadorProveedor
               servicioProveedor
            } 
            actaDefinitivaDoc {
               filename
               tipo
               clave
            }
            actaDefinitivaBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_ACTA_DEFINITIVA + `"){
               envioEncontradoBBDD
               estado
               localizadorProveedor
               servicioProveedor
            }
         }
         listaImpagos {
            uuid
            token
            referenciaCliente
            reclamacionToken
            importe
            importePendiente
            fechaVencimiento
            fechaOrigen
            recuperado
            notas
            fechaAlta
            jsonSegmento
            segmento {
               nombre
               isUsedSegmento
               id
               activo
            }
            pagos {
               importe
               importeRecuperado
               divisa
               fechaPago
               fechaAlta
               observaciones
               comisiona
            }
            reclamacion {
               listadoTransiciones {
                  estadoPrevio
                  estadoPosterior
               }
               estado
               token
            }
         }
         literalOrigenDeudaDetalle(idioma: $idioma) {
            clave
            valor
         }  
         fuente
         literalFuente(idioma: $idioma) {
            clave
            valor
         }   
         producto {
            codigoProducto
            contrato {
               tipo
               literalTipo(idioma: $idioma) {
                  clave
                  valor
               }
               cliente {
                  id
                  nombre
                  apellidos
                  iban
                  fechaAlta
                  idLegal
               }
            }
         } 
         acreedor {
            id
            apellidos 
            cnae
            literalTipoCnae(idioma: $idioma) {
               valor
            }                           
            fechaAlta
            idLegal
            nombre
            razonSocial
            tipo
            literalTipoUsuarioDetalle(idioma: $idioma) {
               valor
            } 
            literalTipoSociedadDetalle(idioma: $idioma) {
               valor
            }                    
         }
         deudor {
            id
            apellidos 
            cnae
            literalTipoCnae(idioma: $idioma) {
               valor
            } 
            fechaAlta
            idLegal
            nombre
            razonSocial
            tipo
            literalTipoUsuarioDetalle(idioma: $idioma) {
               valor
            } 
            literalTipoSociedadDetalle(idioma: $idioma) {
               valor
            }
         }
         envioRequerimiento(idioma: $idioma) {
            servicioProveedor
            literalCodigo
         }
         envioInclusion(idioma: $idioma) {
            servicioProveedor
            literalCodigo
         }
      }
      listadoOrigenesDeuda(idioma: $idioma) {
         clave
         valor
      }
   }
`);
export const QUERY_GET_PAGOS_CUENTA= gql(`
query BusquedaPagosCuenta($filter: [String], $sort: [String], $page: Int!, $size: Int!){
   listaPagosCuenta ( criteria: { filter: $filter, sort: $sort, page: $page, size: $size } ) {
      totalElements
      firstElement
      results {
         id
         referenciaCliente
         importe
         divisa
         fechaPago
         aplicados {
            reclamacionId
            pagoCuentaId
            importe
         }
         usuario {
            nombre
            apellidos
            razonSocial
            tipo
         }
      }
   }
}`);

export const LISTADO_MOTIVOS_CANCELACION_OPERACION = `listadoMotivosCancelacionOperacion(idioma: $idioma) {
   codigo
   clave
   valor 
   idioma
}`
export const LISTADO_MOTIVOS_SUSPENSION_OPERACION = `listadoMotivosSuspension(idioma: $idioma) {
   codigo
   clave
   valor 
   idioma
}`
export const UPLOAD_DOCUMENTO_OPERACION = gql(`
   query subirDocumentoOperacion($uploadDocumentoRequest: UploadDocumentoRequestInput) {
      subirDocumentoOperacion(uploadDocumentoRequest: $uploadDocumentoRequest) {
         filename
         tipo
         clave
      }
   }
`);

export const ALTA_PAGOS_CUENTA = gql(`
   mutation altaPagoCuenta ($altaPagoCuentaRequest: AltaPagoCuentaRequestInput) {
      altaPagoCuenta(altaPagoCuentaRequest: $altaPagoCuentaRequest) {
		   id
			tokenOperacion
			referenciaCliente
			usuarioId
			importe
         divisa
         fechaPago
         usuario {
            nombre
            apellidos
            razonSocial
            tipo
         }
      }
   }
`);

export const EXPORTAR_EXCEL_OPERACION_BY_FILTERS = gql(`
   query exportarExcelOperacionByFilters($lang: String, $criteria: ItemCriteriaInput) {
      exportarExcelOperacionByFilters(lang: $lang, criteria: $criteria) {
         fileData
         fileName
         fileType
         rows
      }
   }
`);

export const QUERY_FLAG_TRANSICIONES_OPERACION= gql(`
   query flagTransicionesOperacion($operacionUuid:String){
      flagTransiciones(uuid: $operacionUuid){
         flagCancelable
         flagRecuperable
         flagSuspendible
         flagOrdenPagable
      }
   }`);

export const QUERY_GET_OPERACION_IDLEGAL_REF = gql(`
   query operacion($idLegalCliente: String, $referenciaCliente: String) {
      operacion (idLegalCliente: $idLegalCliente, referenciaCliente: $referenciaCliente) {
         id
      }
   }
`);